import { Plus, Clock } from "lucide-react";

interface ChatHeaderProps {
  onNewChat: () => void;
  onHistoryClick: () => void;
}

export function ChatHeader({ onNewChat, onHistoryClick }: ChatHeaderProps) {
  return (
    <header className="flex items-center justify-between bg-[#FAF6F1] dark:bg-[#1A2D47] px-4 py-3 h-14">
      <div className="flex items-center gap-3">
        {/* <img src={LogoSvg} alt="Dune Works" className="h-8 w-8" />
        <span className="text-lg font-semibold text-[#1D1B19]">Dune Works</span> */}
      </div>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onNewChat}
          className="inline-flex items-center gap-2 rounded-lg bg-[#051c36] px-3 py-2 text-sm font-medium text-white shadow-md transition hover:bg-[#0c2a4e] hover:scale-[1.02]"
        >
          <Plus size={16} />
          New Chat
        </button>
        <button
          type="button"
          onClick={onHistoryClick}
          className="inline-flex items-center gap-2 rounded-lg border border-[#E5DDD3] dark:border-[#455D7D] bg-white dark:bg-[#2C405F] px-3 py-2 text-sm font-medium text-[#1D1B19] dark:text-[#E3E6EA] shadow-sm transition hover:bg-[#FAF6F1] dark:hover:bg-[#455D7D] hover:scale-[1.02]"
        >
          <Clock size={16} />
          History
        </button>
      </div>
    </header>
  );
}
